import { rem } from 'polished';
import styled from 'styled-components';
import { colorVariantHorizontalSpacingStyles } from '../../../styles/colorVarianStyles';

const ColorVarianStepBarContainer = styled.div`
    ${colorVariantHorizontalSpacingStyles}
    margin-bottom: ${rem(16)};
    opacity: ${({ hasChanged }) => (hasChanged ? 0 : 1)};
    transition: all 0.3s ease-in-out;
`;

export default ColorVarianStepBarContainer;
